import { render, staticRenderFns } from "./_mapMatchOthers.vue?vue&type=template&id=672c1918&scoped=true&lang=pug&"
import script from "./_mapMatchOthers.vue?vue&type=script&lang=js&"
export * from "./_mapMatchOthers.vue?vue&type=script&lang=js&"
import style0 from "./_mapMatchOthers.vue?vue&type=style&index=0&id=672c1918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c1918",
  null
  
)

export default component.exports